import { S3Client, PutObjectCommand } from '@aws-sdk/client-s3'
import { getFileType } from '../file'
import axios from 'axios'

const fileHost = process.env.GLOBAL_CDN_HOST
const bucket = process.env.GLOBAL_S3_BUCKET
const region = process.env.GLOBAL_S3_REGION
const baseUrl = process.env.GLOBAL_API_URL
const fileDir = process.env.GLOBAL_FILE_DIR
const assetsDir = process.env.GLOBAL_ASSETS_DIR
const env = process.env.GLOBAL_ENV
const assetsMixPath = process.env.GLOBAL_DSP_MIX_PATH || ''

const projectKeyList: Record<string, string> = {
    file: fileDir || '',
    assets: assetsDir || '',
}

let stsToken = {
    accessKeyId: 'AKIAQQXV27Z7Q5KOUYWA',
    secretAccessKey: '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',
    sessionToken: 'now',
    // 限时15分钟
    expirationTime: 99999999999999,
}

// 获取临时访问凭证
const getStsToken = async () => {
    const now = new Date().getTime()
    if (stsToken?.expirationTime && now < stsToken?.expirationTime) {
        return stsToken
    }
    const token = localStorage.getItem('token')
    const res = await axios.post(
        baseUrl + '/dsp-admin/api/s3/upload-credential',
        {},
        { headers: { satoken: token?.replace(/"/g, '') || '' } },
    )
    const data = res?.data
    if (data?.code !== 2000) {
        return Promise.reject('获取临时访问凭证失败')
    }
    stsToken = { ...data?.data, expirationTime: now + 1000 * 60 * 15 }
    return stsToken
}

export const getS3Client = async () => {
    const { accessKeyId, secretAccessKey, sessionToken } = await getStsToken()
    const s3Client = new S3Client({
        region: region,
        credentials: {
            accessKeyId: accessKeyId,
            secretAccessKey: secretAccessKey,
            // sessionToken: sessionToken,
        },
        requestChecksumCalculation: 'WHEN_REQUIRED',
    })
    return s3Client
}

/**
 * @description: 通用上传文件,file与blob必须传一个，传入blob时，fileType必传，fileName如非必要不传
 * @return {*}
 */
export const upload = async ({
    file,
    blob,
    fileType,
    fileName,
    projectKey,
}: {
    file?: File
    blob?: Blob
    fileType?: string
    // 如非必要不传
    fileName?: string
    projectKey?: string
}) => {
    if (blob && !fileType) {
        return Promise.reject('blob必须与fileType同时传入')
    }
    const key = projectKey || projectKeyList.file
    const type = fileType || getFileType(file?.name || fileName || '')
    const name = `${new Date().getTime().toString(36)}${Number(
        Math.random().toString().slice(2),
    ).toString(36)}.${getFileType(type)}`
    const params = {
        Bucket: bucket,
        Key: key + `${fileName || name}`, // 存储路径
        Body: file || blob,
    }
    try {
        const s3Client = await getS3Client()
        const data = await s3Client.send(new PutObjectCommand(params))
        if (data?.$metadata?.httpStatusCode === 200) {
            const fileUrl = fileHost + '/' + params.Key
            console.log('fileUrl', fileUrl)
            return fileUrl
        }
        return Promise.reject(data)
    } catch (error) {
        return Promise.reject(error)
    }
}

/**
 * @description: 素材文件上传
 * @return {*}
 */
export const assetsUpload = async ({
    file,
    blob,
    fileType,
    fileName,
}: {
    file?: File
    blob?: Blob
    fileType?: string
    // 如非必要不传
    fileName?: string
}) => {
    const { advertiserId } = JSON.parse(
        localStorage.getItem('userInfo') || '{}',
    )
    const projectKey = `${projectKeyList.assets}${advertiserId || '0'}/`
    const url = await upload({ file, blob, fileType, fileName, projectKey })
    // 生产环境走路径混淆
    // if (env === 'pro') {
    //     return url.replace(projectKeyList.assets, assetsMixPath)
    // }
    return url
}
